module.exports = __webpack_public_path__ + "img/img-acc-complete-char@3x.098f13b2.png";